import { createFileRoute } from '@tanstack/react-router'
import { PanduanStaff } from '../../../../components/PanduanStaff'

export const Route = createFileRoute('/desa/$slug/dashboard/panduan')({
  component: PanduanStaff,
})
